// export const BASE_URL = "http://localhost:8000"
// export const IMAGE_URL = "http://localhost:8000/"
export const BASE_URL = "https://editorbackend.resultsinafrica.com";
export const IMAGE_URL = "https://editorbackend.resultsinafrica.com/";

export const SITE_KEY = "6Lc-KIAqAAAAAFTHfCMBhi1_-wt6IKPB3SYJrwuY";
// y1

export const EDITOR_URL = "https://editor1.resultsinafrica.com/";
// export const EDITOR_URL = "http://localhost:5173/"